import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "settings" }
const _hoisted_2 = {
  key: "settings",
  class: "settings__main"
}
const _hoisted_3 = { class: "settings__title h1 color-text-primary" }
const _hoisted_4 = { class: "settings__sections" }
const _hoisted_5 = {
  key: 0,
  class: "finish-modal__wrap"
}
const _hoisted_6 = { class: "h1 color-white finish-modal__title" }
const _hoisted_7 = { class: "finish-modal__icon" }

import { onMounted, ref } from "vue";
import Details from "@/components/settings/Details.vue";
import AsideModal from "@/components/aside/AsideModal.vue";
import BaseButton from "@/components/base/BaseButton.vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "@/store";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";
import BaseIcon from "@/components/base/BaseIcon.vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'SettingsView',
  setup(__props) {

const step = ref("settings");
const isShowFinishedModal = ref(false);
const router = useRouter();
const route = useRoute();

const store = useStore();
const { t } = useI18n();

const sections = ref([
  {
    title: t("settings.sections.details"),
    step: "details",
  },
  {
    title: t("settings.sections.documentation"),
    step: "docs",
  },
]);

const setSettingsStep = (sectionsStep: string) => {
  if (sectionsStep === "docs") {
    window.open("https://moioperator.ru/preoffer", "_blank");
    return;
  }
  step.value = sectionsStep;
};

const submit = () => {
  isShowFinishedModal.value = true;
  store.dispatch("system/updateAsideVisibility", true);
};

const close = () => {
  isShowFinishedModal.value = false;
  store.dispatch("system/updateAsideVisibility", false);
  step.value = "settings";
};

const clearData = async () => {
  store.dispatch("auth/logout");
};

const goToFeedback = () => {
  router.push("/feedback");
};

onMounted(() => {
  store.dispatch("system/updateAsideVisibility", false);
  if (route.query.details) {
    setSettingsStep("details");
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "tab",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (step.value === 'settings')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)("settings.title")), 1),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: "settings__section h4 color-text-primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (setSettingsStep('docs')))
                }, [
                  _createTextVNode(_toDisplayString(sections.value[1].title) + " ", 1),
                  _createVNode(BaseFigureForIcon, {
                    icon: "more",
                    color: "secondary",
                    size: "small",
                    "is-button": ""
                  })
                ]),
                _createElementVNode("div", {
                  class: "settings__section h4 color-text-primary",
                  onClick: goToFeedback
                }, [
                  _createTextVNode(_toDisplayString(_unref(t)("settings.sections.feedback")) + " ", 1),
                  _createVNode(BaseFigureForIcon, {
                    icon: "more",
                    color: "secondary",
                    size: "small",
                    "is-button": ""
                  })
                ])
              ]),
              _createVNode(BaseButton, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (clearData())),
                title: _unref(t)('settings.logout'),
                size: "large",
                color: "transparent-primary",
                class: "logout-btn"
              }, null, 8, ["title"]),
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "settings__version caption-medium" }, " ver. 1.0 ", -1))
            ]))
          : (step.value === 'details')
            ? (_openBlock(), _createBlock(Details, {
                key: "details",
                onBack: _cache[2] || (_cache[2] = ($event: any) => (step.value = 'settings')),
                onSubmit: submit
              }))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (isShowFinishedModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(AsideModal, {
            "is-show": isShowFinishedModal.value,
            "is-white": false,
            "full-height": true,
            "is-hide-close": true,
            "close-out-side": true,
            onClose: close,
            class: "finish-modal"
          }, {
            default: _withCtx(() => [
              _createElementVNode("h1", _hoisted_6, [
                _createTextVNode(_toDisplayString(_unref(t)("settings.detailsSentLine1")) + " ", 1),
                _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(" " + _toDisplayString(_unref(t)("settings.detailsSentLine2")) + " ", 1),
                _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(" " + _toDisplayString(_unref(t)("settings.detailsSentLine3")), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(BaseIcon, {
                  name: "check-success",
                  folder: "display",
                  class: "icon"
                })
              ]),
              _createVNode(BaseButton, {
                class: "finish-modal__btn",
                color: "white",
                title: "OK",
                onClick: close
              })
            ]),
            _: 1
          }, 8, ["is-show"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})